import { Button } from '../Button';
import { cn } from '../lib/utils';

import type { Props } from './types';

/**
 * The toggle that expands truncated content. Shared so every "Show more" in the
 * app reads the same.
 */
function ShowMoreButton({ className, isExpanded, label = 'Show more', onToggle }: Props) {
  return (
    <Button
      aria-expanded={isExpanded}
      className={cn('mt-0 h-auto py-0 px-0', className)}
      color="secondary"
      onClick={onToggle}
      size="sm"
      variant="ghost">
      {isExpanded ? 'Show less' : label}
    </Button>
  );
}

export { ShowMoreButton };
